import service from "../request/index";
const baseUrl = window.globalUrl.HOME_API;

// 获取远程诊断列表
export const getConsultPageAll = (data) => {
  return service({
    url: `${baseUrl}/trade-website/consult/page`,
    method: "get",
    params: data,
  });
};
